import { Icons } from '..';
import calendar from './icons/calendar.svg';
import engineSimple from './icons/engineSimple.svg';
import correct from './icons/correct.svg';
import logo from './icons/logo.svg';
import info from './icons/info.svg';
import phone from './icons/phone.svg';
import basket from './icons/basket.svg';
import account from './icons/account.svg';
import car from './icons/car.svg';
import carStore from './icons/carStore.svg';
import securePayent from './icons/securePayment.svg';
import squarePlus from './icons/squarePlus.svg';
import infoCircle from './icons/infoCircle.svg';
import manual from './icons/manual.svg';
import fuel from './icons/fuel.svg';
import clockBlack from './icons/IconClockBlack.svg';
import error from './icons/error.svg';
import mail from '../AP/icons/mail.svg';

export const iconsOV = (name: Icons) => {
    switch (name) {
        case Icons.Logo:
            return logo;
        case Icons.Account:
            return account;
        case Icons.Basket:
            return basket;
        case Icons.Calendar:
            return calendar;
        case Icons.EngineSimple:
            return engineSimple;
        case Icons.Info:
            return info;
        case Icons.Phone:
            return phone;
        case Icons.Car:
            return car;
        case Icons.CarStore:
            return carStore;
        case Icons.SecurePayment:
            return securePayent;
        case Icons.Correct:
            return correct;
        case Icons.SquarePlus:
            return squarePlus;
        case Icons.InfoCircle:
            return infoCircle;
        case Icons.Manual:
            return manual;
        case Icons.Mail:
            return mail;
        case Icons.Fuel:
            return fuel;
        case Icons.Clock:
            return clockBlack;
        case Icons.Alert:
            return error;
        default:
            return '';
    }
};
